import { render, staticRenderFns } from "./auths.vue?vue&type=template&id=6cee3dab&"
import script from "./auths.vue?vue&type=script&lang=js&"
export * from "./auths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports